module.exports = __webpack_public_path__ + "img/map.cacc2c6d.svg";